import { VxeUI } from 'vxe-pc-ui';
import { h } from 'vue';
import * as formRenderers from './form-renderers';
import { camel2kebabCase } from '@/utils';

Object.keys(formRenderers).forEach(k => {
    const view = formRenderers[k];
    const itemName = camel2kebabCase(k);
    if (view) {
        VxeUI.renderer.add(itemName, {
            'renderFormItemContent' (renderOpts, renderParams) {
                return h(view, {
                    renderOpts,
                    renderParams,
                });
            },
        });
    }
});
